<template>
  <!-- 推广入口组件 -->
  <div class="promotion-entry">
    <!-- 推广链接入口 -->
    <a 
      :href="promotionLink" 
      target="_blank" 
      class="entry-link"
      @mouseenter="isHovered = true"
      @mouseleave="isHovered = false"
    >
      <div class="entry-content">
        <span class="text">{{ buttonText }}</span>
        <transition name="fade">
          <span v-if="isHovered" class="hover-tip">点击了解详情</span>
        </transition>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'PromotionEntry',
  data() {
    return {
      promotionLink: 'https://example.com', // 替换为实际推广链接
      buttonText: '限时优惠',
      isHovered: false
    }
  }
}
</script>

<style scoped>
/* 固定定位到右下角 */
.promotion-entry {
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 80px;        /* 方形宽度 */
  height: 80px;       /* 方形高度 */
  z-index: 10000;     /* 确保图层置顶 */
}

/* 链接样式 */
.entry-link {
  display: block;
  width: 100%;
  height: 100%;
  text-decoration: none;
  background: linear-gradient(135deg, #ff6b6b, #ff8e8e);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);
  transition: all 0.3s ease;
}

/* 悬停效果 */
.entry-link:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(255, 107, 107, 0.5);
}

/* 内容居中 */
.entry-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  padding: 5px;
  box-sizing: border-box;
}

/* 悬停提示 */
.hover-tip {
  font-size: 10px;
  opacity: 0.9;
  margin-top: 4px;
}

/* 淡入淡出过渡 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/nav/nav-top2.vue